import {
  REGIONLIST,
} from 'actions/region';
import {reducerPackage} from "../../utils";


export const regionList = reducerPackage(REGIONLIST);
